<div  id="wrapper">
    <app-loading-screen></app-loading-screen>
    <app-menu></app-menu>
    <div class="allcont logsize">
      <div class="basicrow">
        <div class="basicrow mbott">
            <div class="container">
                <div>
                    <div class="box-register">
                        <div class="basicrow f-lsemi roboto-r text-center">
                            <div class="basicrow" *ngIf="this.scremView !== 4">
                                <img width="100%" class="mc-icon" src="../../assets/images/reg-a-icon.png">
                                Actualización de Registro
                            </div>
                            <div class="basicrow f-reg f-black m-top-i text-justify" style="line-height: 2;" *ngIf="this.scremView == 1">
                                Hemos detectado cambios en la configuración de su cuenta. Por favor ingrese el número de teléfono con el que desea acceso a Mi Claro.
                            </div>
                            <div class="basicrow f-reg f-black m-top-i text-justify" style="line-height: 2;" *ngIf="this.scremView == 2 && this.typeAccount=='G'">
                                Hemos enviado el código de verificación, Vía SMS. 
                            </div>
                            <div class="basicrow f-reg f-black m-top-i text-justify" style="line-height: 2;" *ngIf="this.scremView == 2 && this.typeAccount!='G'">
                                Por favor ingrese los últimos 4 dígitos de Seguro Social.
                            </div>
                            <div class="basicrow m-top-i" style="    font-size: 14px;     line-height: initial;" *ngIf="this.scremView === 4">
                                Introduce el código de 4 dígitos que hemos enviado a tu número de teléfono que termina en {{this.getLatestSuscriberNumbers()}}.
                            </div>
                        </div>
                        <div *ngIf="this.scremView === 1">
                            <div class="basicrow m-top-i">
                                <label class="label-f">N&uacute;mero de Tel&eacute;fono</label>
                                <div class="basicrow rel">
                                     
                                    <img data-toggle="popover" data-html="true" data-content="Número de Teléfono celular o fijo."
                                    data-placement="bottom" class="q-t-pay" width="100%" src="../../assets/images/tooltip1.png">
                                    <input type="text" maxlength="10" class="inp-f" [(ngModel)]="this.subscriber" [appOnlyNumber]>
                                </div>
                            </div>
                            <div class="basicrow m-top-i">
                                <a (click)="this.validateSubscriber();" class="btns red vcenter">
                                    <span class="tabcell">
                                        Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div *ngIf="this.scremView === 3">
                            <div class="basicrow m-top-i">
                                <div class="basicrow">
                                    <input type="password" placeholder="Código de seguridad" maxlength="4" class="inp-f" [(ngModel)]="this.securityCode" [appOnlyNumber]>
                                </div>
                            </div>
                            <div class="basicrow m-top-i">
                                <a (click)="this.updateRegister();" class="btns gray vcenter" [ngClass]="{red: this.validateInputSecurityCode()}">
                                    <span class="tabcell">
                                        Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                    </span>
                                </a>
                            </div>
                            <div class="basicrow text-center m-top-i" *ngIf="this.scremView==3">
                                ¿No has recibido el código de seguridad?<br>
                                <a (click)="this.resendCode()" class="linkdefs linklogin"> Reenviar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                            </div>
                        </div>
                        <div *ngIf="this.scremView === 2">
                            <div class="basicrow rel m-top-i"  *ngIf="this.typeAccount=='G'">
                                    <label class="label-f">Código de Confirmación</label>
                                    <img data-toggle="popover" data-html="true" 
                                    data-placement="bottom" class="q-t-pay ajustes-top" width="100%" src="../../assets/images/tooltip1.png">
                                    <input type="password" autocomplete="off" placeholder="Código de seguridad" maxlength="6" class="inp-f qt"
                                    ng-keyup="this.checkNumbersOnlySecurityCode()" [(ngModel)]="this.securityCode">

                                    <label class="label-f" style="padding-top: 10px;" (click)="this.resendCode()">¿No has recibido el código de seguridad? <a class="linkdefs linklogin">Reenviar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a></label>
                            </div>
                            <div class="basicrow m-top-i" *ngIf="this.typeAccount!='G'">
                                <label class="label-f">4 &uacute;ltimos de SSN</label>

                                <div class="basicrow">
                                    <input type="password" maxlength="4" class="inp-f" [(ngModel)]="this.ssn" [appOnlyNumber]>
                                </div>
                            </div>
                            <div class="basicrow m-top-i">
                                <a (click)="this.updateRegister();" class="btns vcenter" [ngClass]="{gray: !this.validateInputs(), red: this.validateInputs()}">
                                    <span class="tabcell">
                                        Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div class="basicrow m-top-i">
                            <div class="logline full"></div>
                        </div>
                        <div class="basicrow text-center m-top-i linklogin">
                            <a (click)="this.goToLogin()" class="linkdefs">Volver al inicio de sesi&oacute;n&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>